import React, { useEffect, useState } from "react";
import { Table, Button, UncontrolledTooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import FormBuilder from "../../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Inputs, Buttons, formConfigMapper } from "./AsesoresRow.form";
import { userHasPermission } from "../../../../../utils/accessTree";
import permissionCodes from "../../../../../utils/permissionCodes";

const {
  TRACKING_VENTAS_MEMBRESIA_EDICION_COMPROMISOS_ASESORES: EDICION_COMPROMISOS_ASESORES
} = permissionCodes;

interface Props {
  data: any;
  asesores: any[];
  onUpdate: (index: number, data: any, hasError: boolean) => void;
  onDelete: (index: number) => void;
  saveKey: number;
}

export default function AsesoresTable({
  data,
  asesores,
  onUpdate,
  onDelete,
  saveKey
}: Props) {
  const [periodoAnterior, setPeriodoAnterior] = useState(false);

  useEffect(() => {
    if (data == null) {
      return;
    }

    // Periodo sin cambio de día
    const fechaPeriodo = new Date(`${data.periodo}T00:00:00Z`);
    const mesPeriodo = fechaPeriodo.getUTCMonth();
    const anioPeriodo = fechaPeriodo.getUTCFullYear();

    // Fecha actual
    const fechaActual = new Date();
    const mesActual = fechaActual.getMonth();
    const anioActual = fechaActual.getFullYear();

    // Periodo anterior
    setPeriodoAnterior(
      anioPeriodo < anioActual ||
        (anioPeriodo === anioActual && mesPeriodo < mesActual)
    );
  }, [data]);

  const handleFormChange = (index: number) => (values, hasError) => {
    const updatedItem = {
      ...asesores[index],
      ...values
    };
    onUpdate(index, updatedItem, hasError);
  };

  const tienePermiso = userHasPermission(EDICION_COMPROMISOS_ASESORES);

  if (!asesores || asesores.length === 0) {
    return (
      <div className="text-center text-muted py-4">
        <p>No hay asesores registrados</p>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <Table striped bordered hover size="sm">
        <thead>
          <tr className="bg-dark text-white">
            <th></th>
            <th colSpan={3} className="text-center">
              PUNTOS DE ALCANCE
            </th>
            <th colSpan={3} className="text-center">
              INGRESOS
            </th>
            <th colSpan={3} className="text-center">
              PROSPECTOS
            </th>
            {tienePermiso && <th></th>}
          </tr>
          <tr>
            <th
              style={{
                textAlign: "center",
                width: tienePermiso ? "27%" : "30%",
                maxWidth: tienePermiso ? "27%" : "30%"
              }}
            >
              Vendedores
            </th>
            <th style={{ textAlign: "center", width: "7%", maxWidth: "7%" }}>
              Compromiso
            </th>
            <th style={{ textAlign: "center", width: "7%", maxWidth: "7%" }}>
              Alcance
            </th>
            <th style={{ textAlign: "center", width: "4%", maxWidth: "4%" }}>
              % Pct
            </th>
            <th style={{ textAlign: "center", width: "15%", maxWidth: "15%" }}>
              Compromiso
            </th>
            <th style={{ textAlign: "center", width: "15%", maxWidth: "15%" }}>
              Alcance
            </th>
            <th style={{ textAlign: "center", width: "4%", maxWidth: "4%" }}>
              % Pct
            </th>
            <th style={{ textAlign: "center", width: "7%", maxWidth: "7%" }}>
              Compromiso
            </th>
            <th style={{ textAlign: "center", width: "7%", maxWidth: "7%" }}>
              Alcance
            </th>
            <th style={{ textAlign: "center", width: "4%", maxWidth: "4%" }}>
              % Pct
            </th>
            {tienePermiso && (
              <th
                style={{ textAlign: "center", width: "3%", maxWidth: "3%" }}
              ></th>
            )}
          </tr>
        </thead>
        <tbody>
          {asesores.map((asesor, index) => (
            <tr key={`${saveKey}-${asesor.idAsesor}-${index}`}>
              <td>{asesor.nombreCompleto || "Sin nombre"}</td>
              <FormBuilder<Inputs, Buttons>
                config={formConfigMapper(periodoAnterior)}
                init={{
                  consolidado: asesor.consolidado,
                  consolidadoActual: asesor.consolidadoActual,
                  consolidadoAlcance: asesor.consolidadoAlcance,
                  totalVentas: asesor.totalVentas,
                  totalVentasActual: asesor.totalVentasActual,
                  totalVentasAlcance: asesor.totalVentasAlcance,
                  numeroProspectos: asesor.numeroProspectos,
                  numeroProspectosActual: asesor.numeroProspectosActual,
                  numeroProspectosAlcance: asesor.numeroProspectosAlcance
                }}
                onChange={handleFormChange(index)}
                asTable={true}
              />
              {tienePermiso && (
                <td className="text-center" style={{ verticalAlign: "middle" }}>
                  <>
                    <span
                      id={`del-${asesor.idAsesor}-${index}`}
                      onClick={() => onDelete(index)}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon icon={faTrash} color="#900" />
                    </span>
                    <UncontrolledTooltip
                      placement="top"
                      target={`del-${asesor.idAsesor}-${index}`}
                    >
                      Eliminar asesor
                    </UncontrolledTooltip>
                  </>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
